/**
 * Supplier Over Retail Exception Config
 *
 * Covers: ex-inv-ls-supplier-over-retail
 *
 * Active inventory products where supplier cost > ex-tax retail price.
 */
import { buildProductExceptionConfig } from '../shared/productExceptionColumns'

export const supplierOverRetailConfig = buildProductExceptionConfig({
  codes: ['ex-inv-ls-supplier-over-retail'],
  primaryErrorCode: 'supplier_over_retail',
})
